import React, { useState } from "react";
import QRImagePoller from "./QRImagePoller.jsx";
import { useServiceHook } from "rylak-common";
import { fetchPrepareWarehouseUrls } from "backoffice/src/services";
import { CustomImageNew } from "../../image/CustomImage.jsx";
import ClickableModalImage from "backoffice/src/components/ClickableModalImage.jsx";

export default function UploadedImage(props) {
    const { appProps, system = appProps?.system, uuid } = props;

    let { serviceData: prepareWarehouseImageUrlsServiceData } = useServiceHook({
        appProps,
        fetchRequested: true,
        fetchData: {
            uuid: uuid,
        },
        fetchFn: fetchPrepareWarehouseUrls,
    });

    const [imageBlobFile, setImageBlobFile] = useState(null);

    return (
        <QRImagePoller
            appProps={appProps}
            fetch={system.fetch}
            useServiceHook={useServiceHook}
            uploadUrl={prepareWarehouseImageUrlsServiceData?.data?.uploadURL}
            downloadUrl={prepareWarehouseImageUrlsServiceData?.data?.downloadURL}
            imageBlobFile={imageBlobFile}
            setImageBlobFile={setImageBlobFile}
            readOnly={true}
        >
            <ClickableModalImage imageUrl={imageBlobFile} clickable={true}>
                <CustomImageNew fill style={{ objectFit: "cover" }} src={imageBlobFile} alt="Uploaded image" />
            </ClickableModalImage>
        </QRImagePoller>
    );
}
